import React from "react";
import {
  FaInbox,
  FaPaperPlane,
  FaUsers,
  FaEnvelopeOpenText,
} from "react-icons/fa";
import { LuMessageSquarePlus } from "react-icons/lu";

export default function MessagingHero({
  unreadCount = 0,
  receivedCount = 0,
  sentCount = 0,
  canSendGroup = false,
  onNewMessage,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-sky-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-violet-500/30 blur-3xl" />

      <div className="relative">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
              <FaEnvelopeOpenText className="text-[0.7rem]" />
              Communication club
            </p>

            <h2 className="mt-3 text-2xl font-bold tracking-tight sm:text-3xl">
              Messagerie
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Consulte tes messages, réponds rapidement et envoie des
              informations individuelles ou groupées selon ton rôle.
            </p>

            <div className="mt-4 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaInbox className="text-sky-200" />
                Réception
              </span>

              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaPaperPlane className="text-sky-200" />
                Envoi
              </span>

              {canSendGroup && (
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                  <FaUsers className="text-violet-200" />
                  Groupes
                </span>
              )}
            </div>
          </div>

          <button
            type="button"
            onClick={onNewMessage}
            className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-2xl bg-white px-4 text-sm font-bold text-slate-950 shadow-lg transition hover:bg-white/90"
          >
            <LuMessageSquarePlus />
            Nouveau message
          </button>
        </div>

        <div className="mt-5 grid grid-cols-3 gap-2">
          <HeroStat icon={FaInbox} label="Reçus" value={receivedCount} />
          <HeroStat icon={FaEnvelopeOpenText} label="Non lus" value={unreadCount} />
          <HeroStat icon={FaPaperPlane} label="Envoyés" value={sentCount} />
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>

      <p className="mt-1 text-[11px] font-medium text-slate-300">{label}</p>
    </div>
  );
}